import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from '../../config/config.service';
import { Observable } from 'rxjs';
import { Category } from '../models/category/category';
import { ProductDetails } from '../models/product/product-details';

@Injectable({
  providedIn: 'root',
})
export class ProductService {
  private readonly http = inject(HttpClient);
  private readonly configService = inject(ConfigService);
  private baseUrl: string;

  constructor() {
    this.baseUrl = this.configService.get().END_POINT;
  }

  getCategoriesWithSubcategories(): Observable<Category[]> {
    return this.http.get<Category[]>(`${this.baseUrl}/api/main-categories/user/with-subcategories`);
  }

  getAllProducts(): Observable<ProductDetails[]> {
    return this.http.get<ProductDetails[]>(`${this.baseUrl}/api/products/get-all/website`);
  }

  getProductById(productId: number): Observable<ProductDetails> {
    return this.http.get<ProductDetails>(`${this.baseUrl}/api/products/get/${productId}`);
  }

  getProductImage(imageDetailsId: number): Observable<Blob> {
    return this.http.get(
      `${this.baseUrl}/api/products/get-product-image/${imageDetailsId}`,
      {
        responseType: 'blob'
      }
    );
  }
}
